import {fromEvent, Observable}       from 'rxjs';
import {filter, map, withLatestFrom} from 'rxjs/operators';

import IErrorsPayload from '../../../Player/Interfaces/IErrorsPayload';
import ErrorType      from '../../../Shared/Constants/ErrorType';
import Playback       from '../../../State/Stores/Playback/Playback';

/**
 * Maps error events originating from the video element after the
 * initial manifest/session load has completed to
 * `IErrorsStreamPlayload` objects.
 */

const createVideoErrorEvents = (
    videoElement: HTMLVideoElement,
    playbackStoreUpdate$: Observable<Playback>
): Observable<IErrorsPayload> =>
    fromEvent(videoElement, 'error')
        .pipe(
            withLatestFrom(playbackStoreUpdate$),
            filter(([_, {isLoading}]) => !isLoading),
            map(([source, {hasPlayed}]) => {
                const {error} = (source.target as HTMLVideoElement);
                const code = error ? error.code : null;

                switch (code) {
                    case MediaError.MEDIA_ERR_DECODE:
                        return {
                            type: hasPlayed ?
                                ErrorType.SEGMENT_REQUEST_FAILED_DURING_PLAYBACK :
                                ErrorType.SEGMENT_REQUEST_FAILED_DURING_LOAD,
                            source
                        };
                    default:
                        return {
                            type: ErrorType.UNKNOWN_SOLUTION_ERROR,
                            source
                        };
                }
            })
        );

export default createVideoErrorEvents;